import { render, staticRenderFns } from "./statisticalPeriodModal.vue?vue&type=template&id=463dbdc4&scoped=true"
import script from "./statisticalPeriodModal.vue?vue&type=script&lang=js"
export * from "./statisticalPeriodModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463dbdc4",
  null
  
)

export default component.exports